<!--*****************************************************************
  * Copyright (c) Certus Software, 2021.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<h1 mat-dialog-title>
  {{'app.cookie.details.title' | translate}}
</h1>
<div mat-dialog-content>
  <p class="normal">
    {{'app.cookie.details.info1' | translate}}
  </p>
  <p class="normal">
    {{'app.cookie.details.info2' | translate}}
  </p>
  <p class="normal">
    {{'app.cookie.details.info3' | translate}}
  </p>
  <p class="normal last">
    {{'app.cookie.details.info4' | translate}}
    <br>
    <a href="https://support.google.com/analytics/answer/2763052?hl={{language}}&ref_topic=2919631" target="_blank">{{'app.cookie.details.info5' | translate}}</a>
  </p>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="''" [expandedHeight]="''">
        <mat-panel-title>
          <mat-icon class="menu-button">cookie</mat-icon>SESSIONTOKEN
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="normal">
        {{'app.cookie.details.cookie1' | translate}}
      </p>
      <p class="normal">
        {{'app.cookie.details.cookie1expiry' | translate}}
      </p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="''" [expandedHeight]="''">
        <mat-panel-title>
          <mat-icon class="menu-button">cookie</mat-icon>lang
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="normal">
        {{'app.cookie.details.cookie2' | translate}}
      </p>
      <p class="normal">
        {{'app.cookie.details.cookie2expiry' | translate}}
      </p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="''" [expandedHeight]="''">
        <mat-panel-title>
          <mat-icon class="menu-button">cookie</mat-icon>gdpr
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="normal">
        {{'app.cookie.details.cookie5' | translate}}
      </p>
      <p class="normal">
        {{'app.cookie.details.cookie2expiry' | translate}}
      </p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="''" [expandedHeight]="''">
        <mat-panel-title>
          <mat-icon class="menu-button">cookie</mat-icon>_ga
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="normal">
        {{'app.cookie.details.cookie3' | translate}} <a href="https://support.google.com/analytics/answer/2763052?hl={{language}}&ref_topic=2919631" target="_blank">{{'app.cookie.details.info5' | translate}}</a>
      </p>
      <p class="normal">
        {{'app.cookie.details.cookie3expiry' | translate}}
      </p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header [collapsedHeight]="''" [expandedHeight]="''">
        <mat-panel-title>
          <mat-icon class="menu-button">cookie</mat-icon>_ga_&lt;container-id&gt;
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="normal">
        {{'app.cookie.details.cookie4' | translate}} <a href="https://support.google.com/analytics/answer/2763052?hl={{language}}&ref_topic=2919631" target="_blank">{{'app.cookie.details.info5' | translate}}</a>
      </p>
      <p class="normal">
        {{'app.cookie.details.cookie3expiry' | translate}}
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</div>
<div mat-dialog-actions>
  <button mat-dialog-close class="pushable-icon orange-push" (click)="agreeButton()">
    <span class="front">
      <span>{{'app.cookie.dismiss' | translate}}</span>
    </span>
  </button>
</div>
